import { AlpineComponent } from 'alpinejs';

interface NewsletterAlpineData extends AlpineComponent<Record<string, any>> {
    [key: string]: any;
    openNewsletter(): void;
    closeNewsletter(): void;
}

export default (): NewsletterAlpineData => ({
    openNewsletter(): void {
        this.$store.global.newsletterIsOpen = true;
        const body = document.querySelector('body');
        if (body) {
            body.classList.add('overflow-hidden');
        }
    },
    closeNewsletter(): void {
        this.$store.global.newsletterIsOpen = false;
        const body = document.querySelector('body');
        if (body) {
            body.classList.remove('overflow-hidden');
        }
    },
});
